function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Grupo_72",
  "data-name": "Grupo 72",
  transform: "translate(-109.666 -248)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_11",
  "data-name": "Grupo 11",
  transform: "translate(109.666 248)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_12",
  "data-name": "Caminho 12",
  d: "M109.666,248h15.461l11.829,40.468h-10.48l5.084,33.2L110.392,281h11.777Z",
  transform: "translate(-109.666 -248)",
  fill: "#f28500"
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_12",
  "data-name": "Grupo 12",
  transform: "translate(145.833 263.08)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_13",
  "data-name": "Caminho 13",
  d: "M400.59,420.561V422.4h.072a8.305,8.305,0,0,1,11.908.288h.072a8.342,8.342,0,0,1,6.224-2.662c5.144,0,8.706,3.381,8.706,8.2v11.4h-5.144V429.051c0-2.7-1.583-4.353-4.029-4.353-2.59,0-4.173,1.619-4.173,4.353v10.577H409.3V429.051c0-2.7-1.619-4.353-4.029-4.353-2.591,0-4.209,1.619-4.209,4.353v10.577h-5.144V420.561Z",
  transform: "translate(-395.913 -413.366)",
  fill: "#5c6875"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_14",
  "data-name": "Caminho 14",
  d: "M677.873,420.021c6.332,0,10.361,4.461,10.361,10.253v1.511H672.764c.18,2.482,2.23,4.065,5.4,4.065,2.3,0,3.958-.864,5.864-2.842l3.31,3.31a11.665,11.665,0,0,1-9.138,3.849c-6.656,0-10.685-3.994-10.685-10.037C667.512,424.266,671.865,420.021,677.873,420.021Zm.108,4.317c-2.878,0-4.857,1.439-5.144,3.706h10.217C682.8,425.777,680.823,424.338,677.981,424.338Z",
  transform: "translate(-633.195 -413.366)",
  fill: "#5c6875"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_15",
  "data-name": "Caminho 15",
  d: "M858.987,421.806v1.835h.072a7.371,7.371,0,0,1,5.612-2.194,11.309,11.309,0,0,1,3.13.5l-1.115,4.785a10.963,10.963,0,0,0-2.77-.4c-2.914,0-4.6,1.943-4.6,5.828v8.706h-5.324V421.806Z",
  transform: "translate(-796.109 -414.611)",
  fill: "#5c6875"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_16",
  "data-name": "Caminho 16",
  d: "M975.276,420.021a10.821,10.821,0,0,1,6.3,1.835,8.461,8.461,0,0,1,3.489,4.857l-4.964,1.439a4.792,4.792,0,0,0-4.821-3.454,5.4,5.4,0,0,0,0,10.793,4.693,4.693,0,0,0,4.821-3.454l4.964,1.439a8.459,8.459,0,0,1-3.489,4.856,10.817,10.817,0,0,1-6.3,1.835c-5.936,0-10.541-4.353-10.541-10.073S969.34,420.021,975.276,420.021Z",
  transform: "translate(-892.863 -413.366)",
  fill: "#5c6875"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_17",
  "data-name": "Caminho 17",
  d: "M1143.9,428.259c3.49-.468,4.533-.971,4.533-1.943,0-1.259-1.331-2.015-3.382-2.015-2.446,0-4.281,1.3-4.749,3.418l-5.036-1.043c.719-3.885,4.713-6.655,9.641-6.655,5.576,0,9.03,2.842,9.03,7.483v12.124h-4.785v-2.087h-.072c-1.151,1.619-3.6,2.626-6.44,2.626-4.209,0-7.123-2.3-7.123-5.684C1135.52,430.921,1137.894,429.087,1143.9,428.259Zm4.965,2.015h-.072c-.468.684-1.475,1.079-4.065,1.547-3.13.576-4.245,1.187-4.245,2.3,0,1.151.935,1.655,2.95,1.655a7.435,7.435,0,0,0,3.849-.936,2.715,2.715,0,0,0,1.583-2.3Z",
  transform: "translate(-1041.849 -413.366)",
  fill: "#5c6875"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_18",
  "data-name": "Caminho 18",
  d: "M1314.261,374a9.1,9.1,0,0,1,6.188,2.05h.072v-8.706h5.324V393.61h-4.929v-1.871h-.072a8.407,8.407,0,0,1-6.439,2.411,9.777,9.777,0,0,1-10.325-10.073A9.926,9.926,0,0,1,1314.261,374Zm6.26,8.814c0-2.266-2.518-4.137-5.432-4.137-3.346,0-5.684,2.194-5.684,5.4,0,3.274,2.23,5.36,5.684,5.36,3.022,0,5.432-1.871,5.432-4.209Z",
  transform: "translate(-1189.33 -367.348)",
  fill: "#5c6875"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_19",
  "data-name": "Caminho 19",
  d: "M1509.569,420.008c6.224,0,10.757,4.425,10.757,10.073s-4.533,10.073-10.757,10.073c-6.08.108-10.865-4.5-10.757-10.073C1498.7,424.5,1503.489,419.9,1509.569,420.008Zm0,4.677a5.4,5.4,0,1,0,5.432,5.4A5.165,5.165,0,0,0,1509.569,424.685Z",
  transform: "translate(-1359.457 -413.353)",
  fill: "#5c6875"
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_13",
  "data-name": "Grupo 13",
  transform: "translate(144.195 292.007)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_20",
  "data-name": "Caminho 20",
  d: "M391.577,657.2c3.49-.468,4.533-.971,4.533-1.943,0-1.259-1.331-2.015-3.382-2.015-2.446,0-4.281,1.3-4.749,3.418l-5.037-1.043c.72-3.885,4.713-6.655,9.641-6.655,5.576,0,9.03,2.842,9.03,7.483v12.124h-4.785v-2.087h-.072c-1.151,1.619-3.6,2.626-6.44,2.626-4.209,0-7.123-2.3-7.123-5.684C383.2,659.864,385.569,658.03,391.577,657.2Zm4.965,2.015h-.072c-.468.683-1.475,1.079-4.065,1.547-3.13.576-4.245,1.187-4.245,2.3,0,1.151.935,1.655,2.95,1.655a7.437,7.437,0,0,0,3.849-.936,2.716,2.716,0,0,0,1.583-2.3Z",
  transform: "translate(-382.943 -642.309)",
  fill: "#5c6875"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_21",
  "data-name": "Caminho 21",
  d: "M562.309,648.964a10.82,10.82,0,0,1,6.3,1.835,8.467,8.467,0,0,1,3.49,4.857l-4.965,1.439a4.792,4.792,0,0,0-4.821-3.454,5.4,5.4,0,0,0,0,10.793,4.693,4.693,0,0,0,4.821-3.454l4.965,1.439a8.465,8.465,0,0,1-3.49,4.856,10.818,10.818,0,0,1-6.3,1.835c-5.936,0-10.541-4.353-10.541-10.073S556.373,648.964,562.309,648.964Z",
  transform: "translate(-530.437 -642.309)",
  fill: "#5c6875"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_22",
  "data-name": "Caminho 22",
  d: "M738.072,648.964c6.332,0,10.361,4.461,10.361,10.253v1.511h-15.47c.18,2.482,2.23,4.065,5.4,4.065,2.3,0,3.958-.864,5.864-2.842l3.31,3.31a11.664,11.664,0,0,1-9.138,3.849c-6.656,0-10.685-3.994-10.685-10.037C727.711,653.209,732.064,648.964,738.072,648.964Zm.108,4.317c-2.878,0-4.857,1.439-5.144,3.705h10.217C743,654.72,741.022,653.281,738.18,653.281Z",
  transform: "translate(-684.149 -642.309)",
  fill: "#5c6875"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_23",
  "data-name": "Caminho 23",
  d: "M919.223,596.291v26.262H913.9V596.291Z",
  transform: "translate(-846.812 -596.291)",
  fill: "#5c6875"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_24",
  "data-name": "Caminho 24",
  d: "M988.885,648.964c6.332,0,10.361,4.461,10.361,10.253v1.511H983.776c.18,2.482,2.23,4.065,5.4,4.065,2.3,0,3.958-.864,5.864-2.842l3.31,3.31a11.664,11.664,0,0,1-9.138,3.849c-6.656,0-10.685-3.994-10.685-10.037C978.524,653.209,982.877,648.964,988.885,648.964Zm.108,4.317c-2.878,0-4.857,1.439-5.145,3.705h10.217C993.813,654.72,991.834,653.281,988.993,653.281Z",
  transform: "translate(-903.271 -642.309)",
  fill: "#5c6875"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_25",
  "data-name": "Caminho 25",
  d: "M1170,650.749v1.835h.072a7.371,7.371,0,0,1,5.612-2.194,11.316,11.316,0,0,1,3.13.5l-1.115,4.785a10.963,10.963,0,0,0-2.77-.4c-2.914,0-4.6,1.943-4.6,5.828v8.706H1165V650.749Z",
  transform: "translate(-1066.185 -643.554)",
  fill: "#5c6875"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_26",
  "data-name": "Caminho 26",
  d: "M1284.382,657.2c3.49-.468,4.533-.971,4.533-1.943,0-1.259-1.331-2.015-3.382-2.015-2.446,0-4.281,1.3-4.749,3.418l-5.037-1.043c.719-3.885,4.713-6.655,9.641-6.655,5.576,0,9.03,2.842,9.03,7.483v12.124h-4.785v-2.087h-.072c-1.151,1.619-3.6,2.626-6.439,2.626-4.21,0-7.123-2.3-7.123-5.684C1276,659.864,1278.374,658.03,1284.382,657.2Zm4.965,2.015h-.072c-.468.683-1.475,1.079-4.065,1.547-3.13.576-4.245,1.187-4.245,2.3,0,1.151.935,1.655,2.95,1.655a7.438,7.438,0,0,0,3.85-.936,2.716,2.716,0,0,0,1.583-2.3Z",
  transform: "translate(-1162.941 -642.309)",
  fill: "#5c6875"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_27",
  "data-name": "Caminho 27",
  d: "M1454.737,602.946a9.1,9.1,0,0,1,6.188,2.05H1461v-8.706h5.324v26.262h-4.929v-1.871h-.072a8.407,8.407,0,0,1-6.439,2.411,9.777,9.777,0,0,1-10.325-10.073A9.926,9.926,0,0,1,1454.737,602.946Zm6.26,8.814c0-2.266-2.519-4.137-5.432-4.137-3.346,0-5.684,2.194-5.684,5.4,0,3.274,2.23,5.36,5.684,5.36,3.022,0,5.432-1.871,5.432-4.209Z",
  transform: "translate(-1310.417 -596.291)",
  fill: "#5c6875"
}), /*#__PURE__*/React.createElement("path", {
  id: "Caminho_28",
  "data-name": "Caminho 28",
  d: "M1650.044,648.951c6.223,0,10.756,4.425,10.756,10.073s-4.533,10.073-10.756,10.073c-6.08.108-10.865-4.5-10.757-10.073C1639.179,653.448,1643.964,648.843,1650.044,648.951Zm0,4.677a5.4,5.4,0,1,0,5.432,5.4A5.165,5.165,0,0,0,1650.044,653.628Z",
  transform: "translate(-1480.545 -642.296)",
  fill: "#5c6875"
})));

var SvgLogoLogin = function SvgLogoLogin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 55,
    viewBox: "0 0 214.785 73.673",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoLogin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Logo_login.f507d39f.svg";
export { ForwardRef as ReactComponent };